export const isMetaMessagingEvent = data => {
  const channels = [data.channel, data.message?.channel, data.ticket?.channel,
    data.ticket?.whatsapp?.channel, data.ticket?.contact?.channel, data.contact?.channel];
  return channels.some(channel => ["whatsapp_oficial", "whatsapp_cloud", "facebook", "instagram", "messenger"]
    .includes(String(channel || "").toLowerCase()));
};

export const claimChannelSound = (seen, data, now = Date.now()) => {
  const id = data.message?.wid || data.message?.id;
  if (id === undefined || id === null || id === "") return true;
  const key = `${data.ticket?.companyId || ""}:${data.ticket?.id || data.message?.ticketId || ""}:${id}`;
  for (const [entry, timestamp] of seen) {
    if (now - timestamp > 120000) seen.delete(entry);
  }
  if (seen.has(key)) return false;
  seen.set(key, now);
  if (seen.size > 500) seen.delete(seen.keys().next().value);
  return true;
};
